<template>
  <div class="app-container">
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="个人资料" name="1">
        <userInfo v-if="activeName == 1" @getDetail="userdetail = $event"></userInfo
      ></el-tab-pane>
      <el-tab-pane label="课程记录" name="2">
        <couseRecord v-if="activeName == 2" :user-msg="userdetail"></couseRecord
      ></el-tab-pane>
      <el-tab-pane label="考试记录" name="3">
        <examRecord v-if="activeName == 3" :user-msg="userdetail"></examRecord
      ></el-tab-pane>
      <!-- <el-tab-pane label="订单信息" name="fourth"> </el-tab-pane> -->
    </el-tabs>
  </div>
</template>

<script>
import userInfo from "./components/userinfo.vue";
import couseRecord from "./components/couseRecord.vue";
import examRecord from "./components/examRecord.vue";
export default {
  components: {
    examRecord,
    couseRecord,
    userInfo,
  },
  data() {
    return {
      activeName: "1",
      userdetail: {},
    };
  },
  methods: {},
};
</script>

<style></style>
